import { get as _get } from 'lodash';

import { AppStateActions, AppStateActionTypes } from './app-state.actions';
import { AppState, initialAppState } from './app-state.models';

export function reducer(state = initialAppState, action: AppStateActions): AppState {
  switch (action.type) {
    case AppStateActionTypes.INIT_APP_STATE:
      return Object.assign({}, initialAppState);

    case AppStateActionTypes.SET_SEARCH_TYPE:
      return Object.assign({}, state, {
        ready: true,
        searchType: _get(action, 'payload')
      });
    case AppStateActionTypes.SET_APP_STATE:
      return Object.assign({}, state, {
        appState: _get(action, 'payload')
      });
    case AppStateActionTypes.SET_MAP_REDRAW_TRIGGER:
      return Object.assign({}, state, {
        mapRedrawTriggerState: _get(action, 'payload')
      });

    default:
      return state;
  }
}

export const isReady = (state: AppState) => state.ready;
export const getAppState = (state: AppState) => state.appState;
export const getSearchType = (state: AppState) => state.searchType;
export const getMapRedrawTrigger = (state: AppState) => state.mapRedrawTriggerState;
